module.exports = __webpack_public_path__ + "static/media/rijnmond-min.eb313f5e.png";